import 'babel-polyfill'
import { AppContainer } from 'react-hot-loader'
import React from 'react'
import { render } from 'react-dom'
import App from 'application/root/App'
import configureStore from 'application/store'
import configureApis from 'application/configureApis'
import { initAuth } from 'shared/auth'
import initDFP from 'shared/dfp'
import loadPolyfills from 'application/polyfills'
import { initFonts } from 'shared/fonts'
import { selectShouldRenderAds } from 'services/bootup/selectors'
import { selectUser, selectDFPTargetingAttributes } from 'services/user/selectors'
import configureActionListeners from 'shared/events/actionListeners'

const initialState = window.__STATE__
const apis = configureApis(initialState.bootup)
const store = configureStore(initialState, apis)
configureActionListeners(store, apis)
const rootElement = document.getElementById('root')

initAuth(store)

if (selectShouldRenderAds(initialState)) {
  initDFP(
    selectUser(initialState),
    selectDFPTargetingAttributes(initialState),
    window.googletag,
  )
}

store.dispatch({ type: 'INIT' })

async function initialize () {
  await loadPolyfills()

  initFonts()

  render(
    <AppContainer>
      <App store={store} />
    </AppContainer>,
   rootElement
  )

  if (module.hot) {
    module.hot.accept('./application/root/App', () => {
      // If you use Webpack 2 in ES modules mode, you can
      // use <App /> here rather than require() a <NextApp />.
      const NextApp = require('./application/root/App').default // eslint-disable-line global-require
      render(
        <AppContainer>
          <NextApp store={store} />
        </AppContainer>,
       rootElement
      )
    })
  }
}

// boom goes the dynamite
initialize()
